<div class="row first-hours">
  <div class="col-12 col-lg-6 to-do pt-0 pb-0 pt-md-4 pb-md-5">
    <h4 class="text-black mb-4">WHAT TO DO IN THE FIRST 48 HOURS</h4>
    <div [innerHTML]="data.content"></div>
  </div>
</div>